import type {
  GetRedirectionPathProps,
  MatchRedirectionRouteProps,
} from "./router-redirections.type";

import { generatePath, matchPath } from "react-router";

export const getRedirectionPath = ({
  routes,
  pathname,
  context,
}: GetRedirectionPathProps): string | undefined => {
  for (const route of routes) {
    const redirectPath = matchRedirectionRoute({ route, pathname, context });
    if (redirectPath) return redirectPath;
  }

  return undefined;
};

const matchRedirectionRoute = ({
  route,
  pathname,
  context,
}: MatchRedirectionRouteProps): string | undefined => {
  const match = matchPath({ path: route.from, end: true }, pathname); // exact match only

  if (!match) return undefined;

  if (route.to.includes(":context") && !context) return undefined;

  const params = { ...match.params, context };

  try {
    return generatePath(route.to, params);
  } catch {
    return undefined;
  }
};
